module.exports = __webpack_public_path__ + "img/counter_strike_logo.3e350c7a.svg";